module.exports = __webpack_public_path__ + "img/電気回路_3_10_5.6aca671e.png";